import React from 'react';
import { IPointOfSaleSettingsProps } from 'components/settings/PointOfSaleSettings';
import { TextFormField } from 'lib/form/fields/TextFormField';
import { SettingDisplay } from 'lib/SettingDisplay';
import { PasswordFormField } from 'lib/form/fields/PasswordFormField';
import { DictionaryFormField } from 'lib/form/fields/DictionaryFormField';
import { Box } from '@mui/system';
import { OrderScenario, OrderScenarioLabels, OrderScenarioOptions } from 'components/order/model/Order';

const chargeScenarioOptions = OrderScenarioOptions.filter(
    o => o.value !== OrderScenario.PREORDER && o.value !== OrderScenario.TAKE_OUT
);

// Revenue Center uses TAKEOUT (no underscore) per Toast spec, distinct from Order's TAKE_OUT.
const revenueCenterScenarioOptions = [
    { label: OrderScenarioLabels.PREORDER, value: 'PREORDER' },
    { label: OrderScenarioLabels.TAKE_OUT, value: 'TAKEOUT' }
];

export const ToastSettingsEdit: React.FC<IPointOfSaleSettingsProps> = ({ locationId }) => (
    <>
        {/* Global Only */}
        {locationId === undefined && (
            <>
                <SettingDisplay label="Host">
                    <TextFormField name="toastHost" />
                </SettingDisplay>
                <SettingDisplay label="Client ID">
                    <TextFormField name="toastClientId" />
                </SettingDisplay>
                <SettingDisplay label="Client Secret">
                    <PasswordFormField name="toastClientSecret" type="password" />
                </SettingDisplay>
            </>
        )}

        {/* Location Only */}
        {locationId !== undefined && (
            <>
                <SettingDisplay label="Restaurant GUID">
                    <TextFormField name="toastRestaurantGuid" />
                </SettingDisplay>
                <SettingDisplay label="Payment Type GUID">
                    <TextFormField name="toastPaymentTypeGuid" />
                </SettingDisplay>

                <Box sx={{ mt: 2 }}>
                    <SettingDisplay label="Dining Option Mapping">
                        <DictionaryFormField
                            name="toastScenarioToDiningOptionGuid"
                            keyConfig={{ variant: 'singleSelect', options: OrderScenarioOptions }}
                            valueConfig={{ variant: 'text', placeholder: 'Toast GUID' }}
                            addButtonLabel="Add scenario"
                        />
                    </SettingDisplay>
                </Box>
                <Box sx={{ mt: 2 }}>
                    <SettingDisplay label="Charge Mapping">
                        <DictionaryFormField
                            name="toastScenarioToChargeGuid"
                            keyConfig={{ variant: 'singleSelect', options: chargeScenarioOptions }}
                            valueConfig={{ variant: 'text', placeholder: 'Toast GUID' }}
                            addButtonLabel="Add scenario"
                        />
                    </SettingDisplay>
                </Box>
                <Box sx={{ mt: 2 }}>
                    <SettingDisplay label="Revenue Center Mapping">
                        <DictionaryFormField
                            name="toastScenarioToRevenueCenterGuid"
                            keyConfig={{ variant: 'singleSelect', options: revenueCenterScenarioOptions }}
                            valueConfig={{ variant: 'text', placeholder: 'Toast GUID' }}
                            addButtonLabel="Add scenario"
                        />
                    </SettingDisplay>
                </Box>
            </>
        )}
    </>
);
